import { Component, inject, input } from '@angular/core';
import type { OnInit } from '@angular/core';

import type { RatingScale } from '@core/candidate-evaluation-settings-types';
import type { OfferSelectOption } from '@core/offers-ui';
import type { Placement } from '@core/placements-types';
import {
  EvaluationFieldRefDirective,
  EvaluationFormSubmissionService,
  QuickEvaluationFormService,
} from '@recruitee/evaluations-logic';
import { EvaluationRatingFieldComponent } from '@recruitee/evaluations-ui';

import { EvaluationCommentFieldComponent } from '../../common/evaluation-comment-field/evaluation-comment-field.component';
import { EvaluationJobFieldComponent } from '../../common/evaluation-job-field/evaluation-job-field.component';

@Component({
  selector: 'rt-quick-evaluation-form',
  templateUrl: './quick-evaluation-form.component.html',
  imports: [
    EvaluationFieldRefDirective,
    EvaluationJobFieldComponent,
    EvaluationRatingFieldComponent,
    EvaluationCommentFieldComponent,
  ],
})
export class QuickEvaluationFormComponent implements OnInit {
  private readonly formService = inject(QuickEvaluationFormService);
  private readonly formSubmissionService = inject(EvaluationFormSubmissionService);

  protected readonly quickEvaluationForm = this.formService.form;
  protected readonly submissionAttempted = this.formSubmissionService.submissionAttempted;

  public readonly offers = input<OfferSelectOption[]>([]);
  public readonly preselectedOfferId = input<number>();
  public readonly placements = input<Placement[]>([]);
  public readonly ratingScale = input<RatingScale | null>(null);

  public ngOnInit(): void {
    const [firstOffer] = this.offers();
    const offerId = this.preselectedOfferId() ?? (firstOffer ? Number(firstOffer.id) : undefined);

    this.formService.init(offerId, this.placements());
  }
}
